export const css = {
	root: '_2nBik-GF',
	loading: '_3pYkpB4J',
	instructions: 'wl9_57A6',
	actions: '_3d_W2lUX',
	oneaction: '_1ifObJiX',
	' _key': 'quiz-widgets/flashcard'
};

export default css;
